import angular from 'angular';
const ngRoute = require('angular-route');
import routing from './group.routes';
var localisations = require('./group.localisations');

export class GroupController {
  constructor($http, $scope, socket, common, Auth, subjects, $location, groups, $routeParams) {
    'ngInject';
    var that = this;
    this.$http = $http;
    this.socket = socket;
    this.location = $location;
    this.$routeParams = $routeParams;
    this.common = common;
    this.common.setPageTitle('');
    if (typeof this.$routeParams.group != 'undefined') {
      this.common.setBack(`/messages/${this.$routeParams.group}`, 'arrow_back');
    } else {
      this.common.setBack('/messages', 'arrow_back');
    }
    this.groups = groups;
    this.nogroup = false;
    this.groupId = '';
    Auth.getCurrentUser(function(user) {
      that.currentUser = user;
      if (typeof that.$routeParams.group != 'undefined') {
        console.log('GROUP FROM RP:', that.$routeParams.group);
        that.groupId = that.$routeParams.group;
      } else {
        console.log('GROUP FROM RP:', that.$routeParams.group);
        that.groupId = that.currentUser.group;
      }
      if (typeof that.groupId !== 'undefined' && that.groupId != '') {
        that.groups.myInitialise(that.groupId, that.currentUser._id, function(){
          common.setLoading(false);
          that.nogroup = false;
        }, function(){
          common.setLoading(false);
          that.nogroup = true;
        });
      } else {
        that.nogroup = true;
      }
    });
    this.localisations = localisations[this.common.getLocale()];
  }
}

export default angular.module('ffApp.group', [ngRoute])
  .config(routing)
  .component('group', {
    template: require('./group.html'),
    controller: GroupController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/group/group.component.js